/* eslint-disable indent */
import React, { useState, useEffect, useRef, Fragment } from "react";

import { useDispatch, useSelector } from "react-redux";

import ReactTooltip from "react-tooltip";
import { uploadFileToAws } from "../../../../constant/helper/helper";

import { userActions } from "../../../../redux/actions";
import Card from "../../../../component/card/Card";
import ErrorRender from "../../../../component/request/ErrorRender";
import HeaderTag from "../../../../component/smallComponents/HeaderTag";
import P from "../../../../component/smallComponents/P";
import Strong from "../../../../component/smallComponents/Strong";

import Down from "../../../../images/Down.jpeg";
import Front from "../../../../images/Front.jpeg";
import Left from "../../../../images/Left.jpeg";
import Right from "../../../../images/Right.jpeg";
import Top from "../../../../images/Top.jpeg";
import { helperFunction } from "../../../../constant/helper";
import TopInput from "./TopInput";
import ImageInput from "./ImageInput";
import WebcamInput from "./WebcamInput";
import Starter from "../../../../component/Starter";
import isEmpty from "../../../../validation/isEmpty";

const FaceTypes = {
  Top: "Top",
  Down: "Down",
  Left: "Left",
  Front: "Front",
  Right: "Right"
};

const FaceImageComponents = {
  [FaceTypes.Top]: Top,
  [FaceTypes.Down]: Down,
  [FaceTypes.Left]: Left,
  [FaceTypes.Front]: Front,
  [FaceTypes.Right]: Right
};

const initialData = {
  workerFirstName: "",
  workerSurname: "",
  workerId: "",
  lastLocationId: { locationName: "" }
};

const PhotoRegister = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const webcamRef = useRef(null);
  const [errors, setErrors] = useState("");
  const [imgSrc, setImgSrc] = useState(null);
  const [workerId, setWorkerId] = useState("");
  const [userImage, setUserImage] = useState(null);
  const [faceType, setFaceType] = useState(FaceTypes.Top);
  const [captureImage, setCaptureImage] = useState(false);
  const [userDetailData, setUserDetailData] = useState(initialData);
  const [userImagePreview, setUserImagePreview] = useState(null);

  const { userError, userLoading, userResponse, userDetail } =
    useSelector((state) => state.user);

  useEffect(() => {
    if (userResponse) {
      helperFunction.toastHelper("success", userResponse);
    }
  }, [userResponse]);

  useEffect(() => {
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
  }, [userError]);

  useEffect(() => {
    if (userDetail !== null) {
      setUserDetailData(userDetail);
    }
  }, [userDetail]);

  useEffect(() => {
    dispatch(userActions.setUserLoading(false));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    return () => {
      dispatch(userActions.setUserLoading(false));
      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (userDetailData.workerAadharCardNumber) {
      if (userDetailData.workerAadharCardNumber.length === 12) {
        dispatch(userActions.setUserLoading(true));

        if (userImage) {
          const [, fileExtension] = userImage.type.split("/");

          // upload image to aws and get the link
          const imageFileName =
            userDetailData.workerId +
            "_" +
            faceType +
            "_FACE_REGISTER_" +
            "." +
            fileExtension;

          // upload file to aws
          const { Location, Key } = await uploadFileToAws(
            userImage,
            imageFileName
          );

          if (isEmpty(Location) || isEmpty(Key)) {
            return;
          }

          const userImageInfo = {
            userAadhar: userDetailData.workerAadharCardNumber,
            faceType,
            Location,
            Key,
            workerType: loginType
          };
          setErrors("");
          dispatch(userActions.setUserLoading(true));
          dispatch(userActions.clearUserErrors());
          dispatch(userActions.clearUserResult());
          dispatch(userActions.addPhoto(userImageInfo, loginType));
        } else {
          setErrors("Please Select Input");
        }
      } else {
        setErrors("Aadhar Card must be 12 digit");
      }
    } else {
      setErrors("Please Select all Inputs");
    }
  };

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
  }, [webcamRef, setImgSrc]);

  const showFaceTypeOptions = Object.values(FaceTypes).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  const getDetail = (e) => {
    e.preventDefault();
    const filterBy = "workerId";
    dispatch(
      userActions.getUserDetail(workerId, loginType, filterBy)
    );
  };

  return (
    <Starter
      topBarTitle="Register Face"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Registration Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Registration</a>
          </li>
          <li className="breadcrumb-item active">Register Face</li>
        </Fragment>
      }
    >
      <ReactTooltip
        id="workerId"
        place="top"
        effect="solid"
        type="info"
      >
        Enter Employee Code and Press Get
      </ReactTooltip>

      <Card>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              title="Add Employee Photo"
              isClassName={false}
            />
            <P title="Fill the form below to add Employee Photo" />
          </div>
        </div>
        <TopInput
          workerId={workerId}
          faceType={faceType}
          loginType={loginType}
          getDetail={getDetail}
          captureImage={captureImage}
          userDetailData={userDetailData}
          showFaceTypeOptions={showFaceTypeOptions}
          FaceImageComponents={FaceImageComponents}
          setWorkerId={(e) => setWorkerId(e.target.value)}
          setFaceType={(e) => setFaceType(e.target.value)}
          setCaptureImage={(e) => setCaptureImage(!captureImage)}
        />
        {captureImage ? (
          <WebcamInput
            imgSrc={imgSrc}
            capture={capture}
            onSubmit={onSubmit}
            faceType={faceType}
            webcamRef={webcamRef}
            userLoading={userLoading}
          />
        ) : (
          <ImageInput
            faceType={faceType}
            onSubmit={onSubmit}
            userLoading={userLoading}
            userImagePreview={userImagePreview}
            FaceImageComponents={FaceImageComponents}
            setUserImagePreview={(e) => {
              setUserImagePreview(
                URL.createObjectURL(e.target.files[0])
              );
              setUserImage(e.target.files[0]);
            }}
          />
        )}
        {errors && <ErrorRender errors={errors} />}
      </Card>
    </Starter>
  );
};

export default PhotoRegister;
